import { Navigate, Outlet } from "react-router";
import { useAuth } from "../authentication/useAuth";

const AccountSelectOutlet = () => {
  const { authenticated, user } = useAuth();

  if (!authenticated) {
    return <Navigate to="/" replace />;
  }

  if (user?.customerId && user?.tenantCode) {
    return <Navigate to={`/${user.tenantCode}/${user.customerId}`} replace />;
  }

  return <Outlet />;
};

export default AccountSelectOutlet;
